module.exports = __webpack_public_path__ + "Roboto-Regular-webfont.7f1320f7ec4f6716054d.ttf";


//////////////////
// WEBPACK FOOTER
// C:/Users/gfurtado/Projects/v2.3 (ng4 2.1 only)/Angular 4 CLI/app/src/assets/fonts/roboto/Roboto-Regular-webfont.ttf
// module id = ../../../../../src/assets/fonts/roboto/Roboto-Regular-webfont.ttf
// module chunks = styles